import { HiOutlineMail } from 'react-icons/hi';
import {
	BsCalendarDay,
	BsCardChecklist,
	BsPersonFill,
	BsPersonWorkspace,
} from 'react-icons/bs';
import { CiMoneyCheck1 } from 'react-icons/ci';
import {
	MdOutlineAlarm,
	MdOutlineDataset,
	MdOutlineEventSeat,
	MdOutlineHomeWork,
	MdOutlineToday,
	MdOutlineViewTimeline,
	MdOutlineSettingsInputComponent,
	MdOutlineSyncProblem,
  MdAirplanemodeActive,
} from 'react-icons/md';
import { IoSettingsOutline } from 'react-icons/io5';
import { SiDatabricks } from 'react-icons/si';
import { FaUserCog } from 'react-icons/fa';
import { FaSquareXmark } from 'react-icons/fa6';
import { ReactComponent as IconAccesos } from '../../assets/img/accesos.svg';
import { ReactComponent as IconAsistencia } from '../../assets/img/asistencia.svg';
import { ReactComponent as IconInvitaciones } from '../../assets/img/invitaciones.svg';
import { ReactComponent as IconOrganigrama } from '../../assets/img/organigrama.svg';
import { ReactComponent as IconSolicitudes } from '../../assets/img/solicitudes.svg';
import { ReactComponent as IconPolicy } from '../../assets/img/policy.svg';
import { NotepadIcon } from "@phosphor-icons/react";

export const IconService = (icon, className) => {
	switch (icon) {
		case 'GiOrganigram':
			return <IconOrganigrama className={className} />;
		case 'HiOutlineMail':
			return <IconInvitaciones className={className} />;
		case 'BsPersonFill':
			return <BsPersonFill className={className} />;
		case 'BsCardChecklist':
			return <BsCardChecklist className={className} />;
		case 'BsCalendarDay':
			return <BsCalendarDay className={className} />;
		case 'CiMoneyCheck1':
			return <CiMoneyCheck1 className={className} />;
		case 'MdOutlineEventSeat':
			return <MdOutlineEventSeat className={className} />;
		case 'AiOutlineSchedule':
			return <IconAsistencia className={className} />;
		case 'BsPersonWorkspace':
			return <BsPersonWorkspace className={className} />;
		case 'RiListCheck2':
			return <IconSolicitudes className={className} />;
		case 'IoSettingsOutline':
			return <IoSettingsOutline className={className} />;
		case 'SiDatabricks':
			return <SiDatabricks className={className} />;
		case 'FaUserCog':
			return <FaUserCog className={className} />;
		case 'MdOutlineHomeWork':
			return <MdOutlineHomeWork className={className} />;
		case 'MdOutlineToday':
			return <MdOutlineToday className={className} />;
		case 'MdOutlineAlarm':
			return <MdOutlineAlarm className={className} />;
		case 'MdOutlineViewTimeline':
			return <MdOutlineViewTimeline className={className} />;
		case 'MdOutlineDataset':
			return <MdOutlineDataset className={className} />;
		case 'MdOutlineSettingsInputComponent':
			return <MdOutlineSettingsInputComponent className={className} />;
		case 'MdOutlineSyncProblem':
			return <MdOutlineSyncProblem className={className} />;
		case 'FaSquareXmark':
			return <FaSquareXmark className={className} />;
		case 'GiPadlock':
			return <IconAccesos className={className} />;
		case 'GiVacations':
      return <NotepadIcon className={className} weight="bold" />
		case 'VacationsRequests':
			return <MdAirplanemodeActive className={className} />;
		case 'GiVacationsPolicy':
			return <IconPolicy className={className} />;
		default:
			return <HiOutlineMail className={className} />;
	}
};
